import { useMemo } from 'react';
import { useRMSelector } from 'redux/hooks';
// import { selectWellDetails } from 'redux/selectors/StateSelectors';
import { useCrystalDrawings } from './well';
import { useSelectedTripsCrystals } from './synchrotron';
import { useSelectedDropImageParameters, useLastSelectedWellNavigationDetails } from './experiment';

export const useCheckedCrystals = () => {
  return useRMSelector((state) => state?.plate.checkedCrystalIDs);
};

export const useCrystals = () => {
  const wellNavigationDetails = useLastSelectedWellNavigationDetails();
  const selectedDropImageParameters = useSelectedDropImageParameters();
  const {wellNum, plateID} = wellNavigationDetails || {};
  const {dropNumber, regionName} = selectedDropImageParameters || {};
  return useCrystalDrawings(
    plateID,
    wellNum,
    dropNumber,
    regionName
  );
};

export const useCurrentWell = () => {
  const wellNavigationDetails = useLastSelectedWellNavigationDetails();
  const {wellNum, plateID} = wellNavigationDetails || {};
  return useRMSelector((state) =>
    state.experiment?.expData?.plateDto
      .find((p) => p.plateId == plateID)
      ?.ingredients?.wellList?.find((w) => w.wellNumber == wellNum),
  );
};

export const useCurrentTripCheckedCrystals = () => {
  const selectedTripCrystals = useSelectedTripsCrystals();
  const selectedTripCheckedCrystals = useMemo(() => {
    return selectedTripCrystals?.filter((x) => x.isChecked)?.map((x) => x.id);
  }, [selectedTripCrystals]);

  return selectedTripCheckedCrystals || [];
};